"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get object without particular keys
 */
exports.omitProps = (object, propNames) => {
    return Object.keys(object).reduce((acc, key) => {
        if (propNames.includes(key))
            return acc;
        acc[key] = object[key];
        return acc;
    }, {});
};
//# sourceMappingURL=omitProps.js.map